// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Header-module--cds--assistive-text--edaff";
export var cdsVisuallyHidden = "Header-module--cds--visually-hidden--8a28d";
export var header = "Header-module--header--1890e";
export var headerButton = "Header-module--header-button--7135b";
export var headerName = "Header-module--headerName--d3517";
export var headerNameWithHeaderNav = "Header-module--headerNameWithHeaderNav--1ad95";
export var headerWithHeaderNav = "Header-module--headerWithHeaderNav--3d0c9";
export var hideFeedback = "Header-module--hide-feedback--d8a05";
export var searchIsOpenOnBar = "Header-module--searchIsOpenOnBar--7545d";
export var searchIsOpenOnLink = "Header-module--searchIsOpenOnLink--220c6";
export var showFeedback = "Header-module--show-feedback--1110a";
export var skeleton = "Header-module--skeleton--564a9";
export var skipToContent = "Header-module--skip-to-content--2b66e";
export var switcherButton = "Header-module--switcher-button--16b3a";
export var switcherButtonOpen = "Header-module--switcher-button--open--0177f";